import isPublicFolderComposeViewState from 'owa-mail-compose-store/lib/utils/isPublicFolderComposeViewState';
import closeCompose from '../actions/closeCompose';
import trySaveMessage from '../actions/trySaveMessage';
import trySendMessage from '../actions/trySendMessage';
import { ComposeViewState } from 'owa-mail-compose-store';

export default function handleOnSend(viewState: ComposeViewState): Promise<Error | void> {
    let sendSavePromise;
    if (isPublicFolderComposeViewState(viewState)) {
        sendSavePromise = trySaveMessage(viewState).catch(error => error);
        closeCompose(viewState);
    } else {
        sendSavePromise = trySendMessage(viewState).catch(error => {
            return error;
        });
    }
    return sendSavePromise;
}
